import React, { useEffect, useState, } from 'react';
import { Link, } from 'react-router-dom';

import Swal from 'sweetalert2';
import axios from 'axios';
import $ from 'jquery';

import useAuth from '../../controllers/users/useAuth';
import {
    checkIfUserIsMaster, dataTableLanguaje, responseGet, globalSettings, styles, buttonProcessGet, sendMessageCloseCurrentWindowAsync, awaitDelay, processEvaluateGet,
    languageObjGet, isUndNullEmp, LoadingSection,
} from '../../helpers/settings';
import { buildingModelGet } from '../../models/buildings/building';
import Menu from '../main/Menu';
import BuildingAdd from './BuildingAdd';
import { buildingsByUserGetAsync } from '../../controllers/apartments/apartmentUsers';
import { GlobalFormats } from '../../classes/main/globalFormats';

const currentMethod = 'Buildings';

export default function Buildings({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const auth = useAuth();
    const userRole = checkIfUserIsMaster({ email: auth?.user?.email || '', languageId: languageObj?.id, subMethod: currentMethod, }).result;
    const [showModal, setShowModal] = useState(false);
    const [processType, setProcessType] = useState();
    const [btnCreateDisabled, setBtnCreateDisabled] = useState(true);
    const [showLoading, setShowLoading] = useState(true);
    //const [showData, setShowData] = useState(true);
    //const [showData] = useState(true);
    const dtBuildingsId = 'dtBuildings';
    const controls = {
        buttons: {
            create: {
                //className: 'btn btn-sm btn-outline-primary mx-1',
                //className: 'btn btn-sm btn-outline-primary float-right',
                className: 'btn btn-outline-success float-right btn-sm',
                id: 'btnCreate',
            },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            buildings: {
                inputs: {
                    search: {
                        id: `${dtBuildingsId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtBuildingsId}_length select`,
                        className: '',
                    },
                },
            },
        },
        icons: {
            create: {
                id: 'iconCreate',
                className: globalSettings?.icons?.plusCircle,
            },
        },
        inputs: {
            // email: {
            //     id: 'inputEmail',
            // },
            // password: {
            //     id: 'inputPassword',
            // },
        },
        spinners: {
            create: {
                id: 'spCreate',
                className: '',
            }
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion variables

    //#region buildings
    //const dtBuildingsId = 'dtBuildings';
    const [dtBuildingsRowIndexTwo] = useState(0);
    const [building, setBuilding] = useState({});
    //#endregion buildings

    //#region coins
    //const [coins, setCoins] = useState([]);
    //#endregion coins

    //#region building (methods)
    const buildingAddGetAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'buildingAddGetAsync';
        let response = responseGet();
        try {
            e?.preventDefault();

            //#region variables
            let building = {};
            //#endregion variables

            //sendMessage(2, globalSettings?.messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');
            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region old code
            // //#region get coins
            // headerObj = {
            //     headers: {
            //         authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            //     },
            // };

            // localData = {
            //     conditionals: [
            //         { field: globalSettings?.collections?.properties?.buildingId, operator: globalSettings?.react?.firebase?.operators?.equalTo, value: `${building.id}`, },
            //     ],
            //     ordersBy: [
            //         { field: globalSettings?.collections?.properties?.description, value: 'asc', },
            //     ],
            //     buildingId: building.id,
            // };

            // //result = await axios?.post(`${globalSettings?.app?.backend?.urlDev}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlCoins}/`, localData, headerObj);
            // result = await axios?.post(`${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlCoins}/`, localData, headerObj);
            // response = result.data;

            // if (!response?.isSuccess || response?.isWarning) {
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //     return;
            // }

            // localCoins = response.result;
            // if (isUndefined(localCoins) || isNull(localCoins) || localCoins <= 0) {
            //     sendMessage(1, globalSettings?.messages?.youMustCreateLeastOneCoin?.[languageObj?.id], 0, true, true, null, '');
            //     return;
            // }

            // setCoins(localCoins);
            // //#endregion get coins
            //#endregion old code

            building = buildingModelGet({ userId: auth?.user?.uid });

            setBuilding(building);
            setProcessType(0);
            //sendMessage(-2, '', 0, true, false, null, '');

            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });

            setShowModal(true);
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    const buildingEditDetailGetAsync = async ({ id = '', description = '', rowIndex = 0, processType = 0, subMethod = '', }) => {
        const currentMethod = 'buildingEditDetailGetAsync';
        let response = responseGet();
        try {
            setShowLoading(processType > 0);
            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });

            switch (processType) {
                case 1:
                    window.location.href = `${globalSettings?.app?.backend?.urlBuildingEdit}/${id}`;
                    break;
                case 2:
                    window.location.href = `${globalSettings?.app?.backend?.urlBuildingDetails}/${id}`;
                    break;
                default:
                    break;
            }
            setShowLoading(false);
        } catch (ex) {
            setShowLoading(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    //#region old code
    // const buildingDeleteAsync = async ({ id = '', description = '', rowIndex = 0, subMethod = '', }) => {
    //     const currentMethod = 'buildingDeleteAsync';
    //     let response = responseGet();
    //     try {
    //         //#region check role user
    //         // response = checkUserRole(auth.user);
    //         // if (!response?.isSuccess || response?.isWarning) {
    //         //     sendMessage(response.msgType, replaceMessages(0, response.msgText).result, 0, true, false, null, '');
    //         //     return response;
    //         // }
    //         //#endregion  Check role user

    //         //#region show alert
    //         const swalProperty = {
    //             icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
    //             title: globalSettings?.messages?.areYouSureDeleteThis?.[languageObj?.id],
    //             html: `${globalSettings?.labels?.building?.[languageObj?.id]}: <b>${description}</b><br/>${globalSettings?.messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
    //             timer: null,
    //             confirmButtonColor: globalSettings?.colors?.warningColorExp,
    //             confirmButtonText: globalSettings?.labels?.yes?.[languageObj?.id],
    //             showCancelButton: true,
    //             cancelButtonColor: globalSettings?.colors?.successColorExp,
    //             cancelButtonText: globalSettings?.labels?.no?.[languageObj?.id],
    //             didOpen: () => {
    //                 Swal.hideLoading();
    //             },
    //         };

    //         const { isConfirmed, } = await Swal.fire(swalProperty);

    //         if (isConfirmed) {
    //             //controlsStatusSet({ processType: 1, subMethod: currentMethod, });
    //             setShowLoading(true);

    //             headerObj = {
    //                 headers: {
    //                     authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
    //                     languageId: languageObj?.id,
    //                     description: description,
    //                 },
    //             };

    //             dataObj = {
    //                 url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlBuildings}/${id}`,
    //                 languageId: languageObj?.id,
    //             };

    //             result = await axios.delete(
    //                 dataObj?.url,
    //                 headerObj,
    //             );

    //             response = result.data;

    //             if (!response?.isSuccess || response?.isWarning) {
    //                 //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
    //                 setShowLoading(false);
    //                 await sendMessageCloseCurrentWindowAsync({
    //                     msgType: response?.msgType,
    //                     msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
    //                     closeWindow: false,
    //                     urlGoTo: response?.urlGoTo,
    //                     auth: auth,
    //                     isLogout: false,
    //                     languageId: languageObj?.id,
    //                     subMethod: currentMethod,
    //                 });
    //                 return;
    //             }

    //             $(`#${dtBuildingsId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);
    //             //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
    //             setShowLoading(false);

    //             await sendMessageCloseCurrentWindowAsync({
    //                 msgType: 0,
    //                 msgText: globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id],
    //                 closeWindow: false,
    //                 urlGoTo: response?.urlGoTo,
    //                 auth: auth,
    //                 isLogout: false,
    //                 languageId: languageObj?.id,
    //                 subMethod: currentMethod,
    //             });
    //         }
    //         //#endregion show alert
    //     } catch (ex) {
    //         //controlsStatusSet({ processType: 0, subMethod: currentMethod, });
    //         setShowLoading(false);
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: ${currentMethod}<br/>`;
    //         if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
    //             response.msgText += `Sub method: ${subMethod}<br/>`;
    //         }
    //         response.msgText += `Error: ${ex?.message}`;
    //         await sendMessageCloseCurrentWindowAsync({
    //             msgType: response?.msgType,
    //             msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
    //             closeWindow: false,
    //             urlGoTo: response?.urlGoTo,
    //             auth: auth,
    //             isLogout: false,
    //             languageId: languageObj?.id,
    //             subMethod: currentMethod,
    //         });
    //         return;
    //     }
    // }
    //#endregion old code

    const buildingDeleteAsync = async ({ id = '', description = '', rowIndex = 0, subMethod = '', }) => {
        const currentMethod = 'buildingDeleteAsync';
        let response = responseGet();
        try {
            //#region show message
            let msgTextObj = {
                one: `${globalSettings?.labels?.building?.[languageObj?.id]}: <b>${description}</b><br/>`,
                two: `${globalSettings?.messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            let swalProperties = {
                icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                title: globalSettings?.messages?.areYouSureDeleteThis?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: globalSettings?.colors?.warningColorExp,
                confirmButtonText: globalSettings?.labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: globalSettings?.colors?.successColorExp,
                cancelButtonText: globalSettings?.labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: globalSettings?.react?.sweetAlert2?.icons?.info,
                            title: `${globalSettings?.messages?.processing?.[languageObj?.id]}...`,
                            html: msgTextObj?.one,
                            showConfirmButton: false,
                        });

                        headerObj = {
                            headers: {
                                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                                languageId: languageObj?.id,
                                //description: description,
                            },
                        };

                        dataObj = {
                            url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlBuildings}/${id}`,
                            languageId: languageObj?.id,
                        };

                        result = await axios.delete(
                            dataObj?.url,
                            headerObj,
                        );

                        response = result?.data;

                        if (!response?.isSuccess || response?.isWarning) {
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }

                        $(`#${dtBuildingsId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);

                        await sendMessageCloseCurrentWindowAsync({
                            msgType: 0,
                            msgText: globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id],
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            await Swal.fire(swalProperties);
            //#endregion show message
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }
    //#endregion building (methods)

    //#region others (methods)
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            setShowLoading(true);
            //setShowData(false);

            //#region initialize
            let user = {};
            let buildingsLocal = [];
            //#endregion initialize

            //#region set datatables / Load data table
            response = dataTablesSet({ dtBuildings: true, queryCodeSet_: true, subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading(false);
                //setShowData(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion set datatables / Load data table

            //#region data get
            response = await buildingsByUserGetAsync({
                userRole: userRole,
                auth: auth,
                urlGoTo: globalSettings?.app?.backend?.urlHome,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading(false);
                //setShowData(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            user = response?.result?.user || {};
            setBtnCreateDisabled(!((user?.role?.isMaster || user?.role?.isAdmin) || false));

            if (!isUndNullEmp({ data: response?.result?.buildings, subMethod: currentMethod, })?.result && response?.result?.buildings?.length > 0) {
                const buildings = response?.result?.buildings;
                //setBuildings(localBuildings);
                buildings?.map((detail = buildingModelGet({},)) => (
                    buildingsLocal.push([
                        detail.description,
                        //isUndNullEmp({ data: detail?.contractId, subMethod: currentMethod, })?.result ? globalSettings?.labels?.undefined?.[languageObj?.id] : detail?.contractId,
                        //detail?.contractId || '',
                        detail?.contractId || globalSettings?.labels?.undefined?.[languageObj?.id],
                        buttonProcessGet({
                            id: detail?.id,
                            description: detail?.description,
                            showDetails: true,
                            labelDetails: globalSettings?.labels?.detail?.[languageObj?.id],
                            enabledDetails: processEvaluateGet({
                                object: detail,
                                property: globalSettings?.labels?.process?.en?.toLowerCase(),
                                process: globalSettings?.labels?.detail?.en?.toLowerCase(),
                                subMethod: currentMethod,
                            })?.result,
                            showEdit: true,
                            labelEdit: globalSettings?.labels?.edit?.[languageObj?.id],
                            enabledEdit: processEvaluateGet({
                                object: detail,
                                property: globalSettings?.labels?.process?.en?.toLowerCase(),
                                process: globalSettings?.labels?.edit?.en?.toLowerCase(),
                                subMethod: currentMethod,
                            })?.result,
                            showDelete: true,
                            labelDelete: globalSettings?.labels?.delete?.[languageObj?.id],
                            enabledDelete: processEvaluateGet({
                                object: detail,
                                property: globalSettings?.labels?.process?.en?.toLowerCase(),
                                process: globalSettings?.labels?.delete?.en?.toLowerCase(),
                                subMethod: currentMethod,
                            })?.result,
                            processButtons: [],
                            subMethod: currentMethod,
                        }).result
                    ])
                ));
            }
            //#endregion data get

            setShowLoading(false);
            //setShowData(true);

            //#region set datatables / Load data table
            //#region old code
            // response = dataTablesSet({ dtBuildings: true, queryCodeSet_: true, subMethod: currentMethod, });
            // if (!response?.isSuccess || response?.isWarning) {
            //     setShowLoading(false);
            //     //setShowData(false);
            //     await sendMessageCloseCurrentWindowAsync({
            //         msgType: response?.msgType,
            //         msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
            //         closeWindow: false,
            //         urlGoTo: response?.urlGoTo,
            //         auth: auth,
            //         isLogout: false,
            //         languageId: languageObj?.id,
            //         subMethod: currentMethod,
            //     });
            //     return;
            // }
            //#endregion old code

            $(`#${dtBuildingsId}`)?.DataTable()?.rows?.add(buildingsLocal)?.draw(true);
            //#endregion set datatables / Load data table
        } catch (ex) {
            setShowLoading(false);
            //setShowData(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dtBuildingsSet = ({ subMethod = '', }) => {
        const currentMethod = 'dtBuildingsSet';
        let response = responseGet();
        try {
            $(`#${dtBuildingsId}`)?.DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: globalSettings?.labels?.description?.[languageObj?.id], width: '70%', },
                    { title: globalSettings?.labels?.contract?.[languageObj?.id], width: '25%', },
                    { title: globalSettings?.labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                //}).buttons().container().appendTo(`#${dtBuildingsId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const queryCodeSet = ({ subMethod = '', }) => {
        const currentMethod = 'queryCodeSet';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let method = '';
            let description = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            //#endregion variables

            $(`#${dtBuildingsId} tbody`)?.on('click', 'tr', 'td', async function (e) {
                e?.preventDefault();
                rowIndex = $(`#${dtBuildingsId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = (!isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex);
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    method = e?.target?.attributes?.method?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'edit':
                            buildingEditDetailGetAsync({ id: id, description: description, rowIndex: dtRowIndex, processType: 1, subMethod: currentMethod, });
                            break;
                        case 'details':
                            buildingEditDetailGetAsync({ id: id, description: description, rowIndex: dtRowIndex, processType: 2, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            buildingDeleteAsync({ id: id, description: description, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const dataTablesSet = ({ dtBuildings = false, queryCodeSet_ = false, subMethod = '', }) => {
        const currentMethod = 'dataTablesSet';
        let response = responseGet();
        try {
            if (dtBuildings) {
                response = dtBuildingsSet({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }

            if (queryCodeSet_) {
                response = queryCodeSet({ subMethod });
                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.icons?.create?.id}`)?.removeClass();
                    $(`#${controls?.buttons?.create?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.create?.id}`)?.removeClass();

                    $(`#${controls?.icons?.create?.id}`)?.addClass(controls?.icons?.create.className);
                    $(`#${controls?.buttons?.create?.id}`)?.addClass(controls?.buttons?.create?.className);
                    $(`#${controls?.spinners?.create?.id}`)?.addClass(controls?.spinners?.create.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.create?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.buttons?.create?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                    $(`#${controls?.icons?.create?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.create?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region old code
            // $(`#${controls?.inputs?.email?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.password?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.checkBox?.remenberMe?.id}`).attr('disabled', (processType !== 0));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            $(`#${controls?.dataTables?.buildings?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.buildings?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            if (processType !== 0) {
                $(`#${controls?.buttons?.create?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                //$(`#${controls?.buttons?.home?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'onLoad - form', });
    }, []) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others (methods)

    return (
        <div>
            <Menu viewName='process' process='buildings' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{globalSettings?.labels?.buildings?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{globalSettings?.labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{globalSettings?.labels?.buildings?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <div className='row'>
                            <div className='col-12'>

                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={globalSettings?.messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={globalSettings?.labels?.buildings?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.buildingsLogo}></img> - {globalSettings?.labels?.index?.[languageObj?.id]}
                                        </h6>
                                        <div className='card-tools'>
                                            <button type='button'
                                                className='btn btn-tool'
                                                data-card-widget='collapse'>
                                                <i className={globalSettings?.icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div> {/*card header*/}

                                    <div className='card-body'>

                                        <div className='row'>
                                            <div className='col-md-12'>
                                                {/* {!showLoading ? */}
                                                <div>
                                                    {/* {showData ? */}
                                                    <div>
                                                        <button id={controls?.buttons?.create?.id}//disabled={!isUserMaster}
                                                            disabled={btnCreateDisabled}
                                                            tooltip='tooltip'
                                                            title={globalSettings?.labels?.create?.[languageObj?.id]}
                                                            className={controls?.buttons?.create?.className}
                                                            onClick={(e) => buildingAddGetAsync({ e: e, subMethod: 'btn - create', })}
                                                            type='button'>
                                                            <i id={controls?.icons?.create?.id} className={controls?.icons?.create?.className} /> <span id={controls?.spinners?.create?.id} className='' aria-hidden='true'></span>
                                                        </button>
                                                        <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                            <table id={dtBuildingsId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                        </div>
                                                    </div>
                                                    {/* //     :
                                                    //     <div></div>
                                                    // } */}
                                                </div>
                                                {/* // :
                                                    // <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                                                    //     width={40}
                                                    //     height={40}
                                                    //     color={globalSettings?.colors?.infoColorExp}
                                                    //     msgText={globalSettings?.messages?.processing?.[languageObj?.id]}
                                                    //     msgOrientation='text-center'
                                                    //     msgTextMuted={true} />
                                                // } */}
                                            </div>
                                        </div>

                                    </div> {/*card body*/}

                                    <div className='card-footer'></div> {/*card footer*/}

                                </div>{/*card*/}

                            </div>{/*col*/}
                        </div>{/*row*/}

                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content */}

            </div >

            {showModal &&
                //!isUndefined(building) && !isNull(building) && !isEmpty(building) &&
                //!isUndefined(coins) && !isNull(coins) ?
                //   <BuildingAdd $={$}
                //     auth={auth}
                //     showModal={showModal}
                //     setShowModal={setShowModal}
                //     userRole={userRole}
                //     building={building}
                //     setBuilding={setBuilding}
                //     coins={coins}
                //     dtBuildingsId={dtBuildingsId}
                //     dtBuildingsRowIndex={dtBuildingsRowIndexTwo}
                //     processType={processType} />
                !isUndNullEmp({ data: building, subMethod: currentMethod, })?.result ?
                <BuildingAdd processValues={{
                    $,
                    auth,
                    showModal,
                    setShowModal,
                    userRole,
                    building,
                    setBuilding,
                    dtBuildingsId,
                    dtBuildingsRowIndex: dtBuildingsRowIndexTwo,
                    processType,
                    languageObj,
                }} />
                :
                <></>
            }
        </div >
    )
}